<template>

  <div id="page-forms">

    <v-form
      v-model="formdata.valid"
      ref="validateform"
      lazy-validation
    >
      <!-- <v-layout
        row
        wrap
      >

        <v-flex
          xs12
          sm12
        >
          <v-text-field
            v-model="formdata.parentFolderID"
            label="Parent Folder ID"
            prepend-icon="description"
          >
            <div slot="label">
              Parent Folder ID
            </div>
          </v-text-field>
        </v-flex>
        <v-flex
          xs12
          sm12
        >
          <v-text-field
            v-model="formdata.mainFolderID"
            label="Main Folder ID"
            prepend-icon="description"
          >
            <div slot="label">
              Main Folder ID
            </div>
          </v-text-field>
        </v-flex>
        <v-flex
          xs12
          sm12
        >
          <v-text-field
            v-model="formdata.folderTypeID"
            label="Folder Type ID"
            prepend-icon="description"
          >
            <div slot="label">
              Folder Type ID
            </div>
          </v-text-field>
        </v-flex>
        <v-flex
          xs12
          sm12
        >
          <v-text-field
            v-model="formdata.name"
            label="Name"
            :rules="formdata.nameRules"
            required
            prepend-icon="select_all"
          ></v-text-field>
        </v-flex>
        <v-flex
          xs12
          sm12
        >
          <v-text-field
            v-model="formdata.description"
            label="Description"
            prepend-icon="description"
          >
            <div slot="label">
              Description
            </div>
          </v-text-field>
        </v-flex>
        <v-flex
          xs12
          sm6
          md4
        >
          <v-autocomplete
            label="Status"
            prepend-icon="notes"
            v-model="formdata.statusCodeID"
            :items="statusOptions"
          >
          </v-autocomplete>
        </v-flex>

        <v-flex
          sm2
          lg2
        >
          <v-btn
            color="primary"
            @click="openUpload"
          >Upload</v-btn>

        </v-flex>

      </v-layout> -->

    </v-form>
    </v-dialog>
    <!-- <v-dialog
      v-model="uploadFile"
      max-width="700px"
      scrollable
      @close="closeDial"
    >
      <v-card>
        <v-form
          v-model="formdata.valid"
          ref="form"
          lazy-validation
        >
          <v-card-title>
            <span>File Upload</span>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-card-text>
            <p><b>Read & Write</b></p>
            <p><b>Read Only</b></p>
            
            <upload-btn
              :fileChangedCallback="fileChanged"
              title="Browse"
              name="uploadfolder"
              uniqueId
            >
              <template slot="icon-left">
                <v-icon
                  left
                  color="white"
                >attachment</v-icon>
              </template>
            </upload-btn>
            <div class="large-12 medium-12 small-12 cell">
              <div
                v-for="(file, key) in uploadedFiles"
                class="file-listing"
              >{{ file.name }}
                <v-btn
                  icon
                  v-if="!showdownload"
                  @click="removeFile( key )"
                >
                  <v-icon>close</v-icon>
                </v-btn>
                <v-btn
                  icon
                  v-if="showdownload"
                  @click="downloadFile( key )"
                >
                  <v-icon>save_alt</v-icon>
                </v-btn>
              </div>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              outline
              color="primary"
              @click.native="save"
            >Upload</v-btn>
            <v-btn
              outline
              color="primary"
              @click="uploadFile = false"
            >Close</v-btn>

          </v-card-actions>
        </v-form>
      </v-card>
      
    </v-dialog> -->

  </div>
  <!-- </vue-perfect-scrollbar> -->
</template>

 <script>
import UploadButton from 'vuetify-upload-button';
import Bytes from 'bytes';
import { uploadDocuments, downloadFile, documentUsers, createDocumentAccess, updateDocumentAccess } from '@/api/document';
import { getSubFoldersId, getSubFolders, getFolderTreeId, createFolders, updateFolders, deleteFolders, getFolderFiles, getFolder, getFolderTypes, getFolders } from '@/api/folder';
import GlobalMessage from '@/constant'
import moment from 'moment'
import Editor from '@toast-ui/vue-editor/src/editor.vue'

export default {

  components: {
    'upload-btn': UploadButton,

    // quillEditor,
    Editor,

  },

  data: () => ({
    scrollSettings: {
      maxScrollbarLength: 160
    },
    // folderAccessPermission: {      assignedCc: [],
    //   assignedTo: [], onBehalfID: null    },
    documentAccess: {      userIDs: [], assignedRights: [],
      documentID: null, documentAccessID: null    },
    // personalTags: [

    // ],
    statusOptions: [
      { text: 'Active', value: 1 },
      { text: 'InActive', value: 2 }
    ],
    editorText: 'This is initialValue.',
    editorOptions: {
      hideModeSwitch: true
    },
    editorHtml: '',
    editorVisible: true,
    search: null,
    folderStatus: [
      { status: 'Draft', statusCodeID: 511 },
      { status: 'Assigned', statusCodeID: 512 },
      { status: 'Completed', statusCodeID: 513 },
      { status: 'Cancelled', statusCodeID: 514 },
      { status: 'Closed', statusCodeID: 516 }],

    //personalTags: [{ tagId: 1, tag: 'Demo' }],
    parentFolderDropItems: [],
    folderTypeDropItems: [],
    mainFolderDropItems: [],
    editorOption: {
      // theme: 'bubble',
      // placeholder: "输入任何内容，支持html",
      // modules: {
      //   toolbar: [
      //     ['bold', 'italic', 'underline', 'strike'],
      //     [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      //     [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      //     [{ 'color': [] }, { 'background': [] }],
      //     [{ 'font': [] }],
      //     [{ 'align': [] }],
      //     ['link', 'image'],
      //     ['clean']
      //   ]
      // }
    },
    menudue: false,
    loader: false,
    size: 'lg',
    view: 'grid',
    folder: false,
    dropUsers: [],
    subfolderfiles: new FormData(),

    uploadFile: false,
    conversationFile: false,
    formdata: {
      valid: false,
      folderID: -1,
      date: new Date().toISOString().substr(0, 10),
      title: '',
      mainFolderID: null,
      parentFolderID: null,
      name: '',
      folderTypeID: null,
      description: '',
      readonlyUserID: [],
      readWriteUserID: [],
      selAssignedRights: [],
      sessionID: '',
      addedByUserID: 1,
      addedDate: new Date().toISOString().substr(0, 10),
      addedByUser: 'Arun',
      statusCodeID: 511,
      statusCode: 'Active',
      modifiedByUserID: 1,
      modifiedDate: new Date().toISOString().substr(0, 10),
      requiredfield: [v => !!v || 'This is required field'],
      addedByUser: 'Arun',
      attachments: [],
      documentID: -1,
      documentAccessID: null,
      documentAccessName: null,
      sessionID: null,
      linkID: null,
      // isSpecialFile: true,
      // isTemp: true,
      // isUrgent: false,
      uploadedFile: null,

    },
    defaultData: {
      valid: false,
      folderID: -1,
      date: new Date().toISOString().substr(0, 10),
      title: '',
      mainFolderID: null,
      parentFolderID: null,
      name: '',
      folderTypeID: null,
      // assignedTo: [],
      // dueDate: new Date().toISOString().substr(0, 10),
      description: '',
      // projectID: null,
      // assignedCC: [],
      // onBehalfID: null,
      sessionID: '',
      addedByUserID: 1,
      addedDate: new Date().toISOString().substr(0, 10),
      addedByUser: 'Arun',
      statusCodeID: 511,
      statusCode: 'Active',
      modifiedByUserID: 1,
      modifiedDate: new Date().toISOString().substr(0, 10),
      requiredfield: [v => !!v || 'This is required field'],
      // tagMasterID: -1,
      // tagIds: [],
      // personaltagIds: [],
      addedByUser: 'Arun',
      attachments: [],
      documentID: -1,
      documentAccessID: null,
      documentAccessName: null,
      readonlyUserID: [],
      readWriteUserID: [],
      sessionID: null,
      // linkID: null,
      // isSpecialFile: true,
      // isTemp: true,
      // isUrgent: false,
      // description: '',
      uploadedFile: null,
      // onBehalfName: '',
      // overDueAllowed: 'false',
      // followUp: 'false',
      // mainTaskId: null,
      userGroupID: -1,
    },
    // dueDate: new Date(),
    // tagItems: [],
    // projectItems: [],
    userItems: [],
    // userCCItems: [],
    // userToItems: [],
    userGroupItems: [],
    // cCItems: [],
    items: [],
    folderItems: [],
    folderItemLink: [],
    allFiles: [],
    uploadedFiles: [],
    showDownLoad: false,
    editFile: {
      name: '',
      size: '',
      contentType: '',
    },
    height: {
      type: String,
      default: null,
    },
    foldertriggered: false,
  }),
  computed: {
    computeHeight () {
      return {
        height: this.height || ''
      };
    },
    computedDateFormattedMomentjs () {
      return this.date ? moment(this.date).format('dd, MM Do YYYY') : ''
    },
    computedDateFormattedDatefns () {
      return this.date ? format(this.date, 'dd, MM Do YYYY') : ''
    }
  },
  watch: {
    model (val) {
      if (val.length > 5) {
        this.$nextTick(() => this.model.pop())
      }
    },
    uploadFile (val) {
      val || this.closeDial();
    }
  },
  computed: {
    editor () {
      return this.$refs.myTextEditor.quill
    },
    formattedDate () {
      return this.dueDate ? moment(this.dueDate).format('DD/MM/YYYY') : undefined; // Custom format
    },
  },
  mounted () {

  },
  created () {

    window.getApp.$on('SAVE_FOLDER', () => {
      this.save();
    });
    window.getApp.$on('SEND_FOLDEROBJ', item => {

      this.formdata = item;
      // window.getApp.$emit('INITIALIZE_FOLDERFILE', -1);
      // this.$eventHub.$emit('INITIALIZE_FOLDERCONVER', -1);
      // window.getApp.$emit('INITIALIZE_SUBFOLDER', -1);
      this.initialize();
    });
    window.getApp.$on('INITIALIZE_FOLDER', day => {

      this.dueDate = day;
      // window.getApp.$emit('INITIALIZE_FOLDERFILE', -1);
      // this.$eventHub.$emit('INITIALIZE_FOLDERCONVER', -1);
      // window.getApp.$emit('INITIALIZE_SUBFOLDER', -1);
      this.initialize();
    });

    window.getApp.$on('EDIT_FOLDER', item => {
      this.initialize();
      // alert('EDIT_TASK');
      this.formdata = item;
      this.showdownload = true;
      this.uploadedFiles = [];
      window.getApp.$emit('INITIALIZE_FOLDERFILE', this.formdata);
      this.$eventHub.$emit('INITIALIZE_FOLDERCONVER', this.formdata);
      window.getApp.$emit('INITIALIZE_SUBFOLDER', this.formdata.mainTaskId);
      window.getApp.$emit('SEND_FOLDEROBJ', this.formdata);
      this.formdata.dueDate = this.formateDate(item.dueDate);

    });

  },
  beforeDestroy () {

  },
  methods: {
    onEditorChange ({ editor, html, text }) {


    },
    inputHandler (date) {
      if (typeof date === 'string')
        date = moment(date).toDate();
      this.isActive = false;
      this.dueDate = date;
    },
    formateDate (string) {
      return string ? new Date(string).toISOString().substr(0, 10) : '';
    },
    // removeTag (item) {

    //   const index = this.formdata.tagIds.indexOf(item.tagMasterID)
    //   if (index >= 0) this.formdata.tagIds.splice(index, 1)
    // },
    // removeCC (item) {
    //   const index = this.formdata.assignedCC.indexOf(item.userID)
    //   if (index >= 0) this.formdata.assignedCC.splice(index, 1)
    // },
    removeReadOnly (item) {
      const index = this.formdata.readonlyUserID.indexOf(item.userID)
      if (index >= 0) this.formdata.readonlyUserID.splice(index, 1)
    },

    removeReadWrite (item) {
      const index = this.formdata.readWriteUserID.indexOf(item.userID)
      if (index >= 0) this.formdata.readWriteUserID.splice(index, 1)
    },
    // removeTo (item) {
    //   const index = this.formdata.assignedTo.indexOf(item.userID)
    //   if (index >= 0) this.formdata.assignedTo.splice(index, 1)
    // },
    // removeBehalf (item) {

    //   this.formdata.onBehalfID = null;
    // },
    removeStatus (item) {
      this.formdata.statusCodeID = null;
    },
    // removeProject (item) {
    //   //const index = this.projectItems.indexOf(item)
    //   this.formdata.projectID = null;
    // },
    // removePTag (item) {
    //   const index = this.formdata.personaltagIds.indexOf(item)
    //   if (index >= 0) this.formdata.personaltagIds.splice(index, 1)
    // },
    initialize () {

      this.uploadedFiles = [];
      this.formdata = Object.assign({}, this.defaultData);
      this.formdata.addedByUser = this.$store.state.auth.userName;
      this.loader = true;
      //this.formdata.dueDate = new Date(this.dueDate).toISOString().substr(0, 10);

      getFolders('')
        .then(response => {
          this.gridItems = response.data;
          this.parentFolderDropItems = response.data;
          this.mainFolderDropItems = response.data;
          //this.folderTypeDropItems = response.data;
          this.loader = false;
          console.log(this.gridItems);
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
      getFolderTypes('')
        .then(response1 => {
          //this.gridItems = response1.data;
          this.folderTypeDropItems = response1.data;
          this.loader = false;
          //console.log(this.gridItems);
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
      // getApplicationUsers('')
      //   .then(response1 => {


      //     this.userCCItems = response1.data;
      //     this.userToItems = response1.data;

      //     this.loader = false;

      //   })
      //   .catch(error => {
      //     this.loader = false;
      //     window.getApp.$emit('APP_API_ERROR', error);
      //   });
      // getUserGroups('')
      //   .then(response2 => {
      //     this.userGroupItems = response2.data;

      //     this.loader = false;

      //   })
      //   .catch(error => {
      //     this.loader = false;
      //     window.getApp.$emit('APP_API_ERROR', error);
      //   });
      // console.log(this.userGroupItems);
      // getUserById(this.userGroupItems)
      // .then(response3 => {
      //   this.userItems = response3.data;

      //   this.loader = false;

      // })
      // .catch(error => {
      //   this.loader = false;
      //   window.getApp.$emit('APP_API_ERROR', error);
      // });
      // getProjects('')
      //   .then(response2 => {
      //     this.projectItems = response2.data;
      //     this.loader = false;

      //   })
      //   .catch(error => {
      //     this.loader = false;
      //     window.getApp.$emit('APP_API_ERROR', error);
      //   });

      // getTagMaster('')
      //   .then(response => {
      //     this.tagItems = response.data;
      //     this.loader = false;
      //   })
      //   .catch(error => {
      //     this.loader = false;
      //     window.getApp.$emit('APP_API_ERROR', error);

      //   });
      // getPersonalTags(-1, this.$store.state.auth.userId)
      //   .then(response => {
      //     this.PersonaltagItems = response.data;
      //     this.loader = false;
      //   })
      //   .catch(error => {
      //     this.loader = false;
      //     window.getApp.$emit('APP_API_ERROR', error);

      //   });

    },
    // getAttachments () {
    //   getTaskAttachment(this.formdata.folderID)
    //     .then(response => {

    //       this.editFile.name = response.data[0].fileName;
    //       this.editFile.contentType = response.data[0].contentType;
    //       this.editFile.size = response.data[0].fileSize;
    //       this.showdownload = true;

    //       this.uploadedFiles.push(this.editFile);
    //       this.loader = false;

    //     })
    //     .catch(error => {
    //       this.loader = false;
    //       window.getApp.$emit('APP_API_ERROR', error);
    //     });
    // },
    openUpload () {
      // this.folderAccessPermission.assignedCc = this.formdata.assignedCC;
      // this.folderAccessPermission.assignedTo = this.formdata.assignedTo;

      this.uploadFile = true;
      // this.cCItems.push(this.formdata.userItems);
      // this.cCItems.push(this.formdata.assignedTo);
      // this.cCItems.push(this.formdata.assignedCC);
      // this.cCItems.push(this.formdata.onBehalfID);
      // this.folderAccessPermission.assignedCc.push(this.formdata.assignedTo);
      // if (this.formdata.onBehalfID != 0) {
      //   this.folderAccessPermission.onBehalfID = this.formdata.onBehalfID;
      //   // this.folderAccessPermission.assignedCC.push(this.formdata.onBehalfID);
      // }

      // getUsers(this.folderAccessPermission)
      //   .then(response1 => {
      //     //this.cCItems = response1.data;

      //     //this.$refs.reffolderfiles.folderAccessPermission.onBehalfID = this.folderAccessPermission.onBehalfID;
      //     this.loader = false;

      //   })
      //   .catch(error => {
      //     this.loader = false;
      //     window.getApp.$emit('APP_API_ERROR', error);
      //   });
    },
    conversation () {
      window.getApp.$emit('TAB_CONVERSATION');


    },
    getuser () {

    },
    // userGroupCC (value) {
    //   getUserById(value)
    //     .then(response3 => {
    //       this.userCCItems = response3.data;

    //       this.loader = false;

    //     })
    //     .catch(error => {
    //       this.loader = false;
    //       window.getApp.$emit('APP_API_ERROR', error);
    //     });
    // },
    // userGroupTo (value) {
    //   getUserById(value)
    //     .then(response4 => {
    //       this.userToItems = response4.data;

    //       this.loader = false;

    //     })
    //     .catch(error => {
    //       this.loader = false;
    //       window.getApp.$emit('APP_API_ERROR', error);
    //     });
    // },
    fileChanged (file) {

      this.uploadedFiles.push(file);
      this.showdownload = false;
      this.loader = true;
      this.subfolderfiles.append("file", file, file.name);
      uploadDocuments(this.subfolderfiles)
        .then(response => {
          this.formdata.sessionID = response.data;
          this.loader = false;
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });

    },
    removeFile (key) {
      this.uploadedFiles.splice(key, 1);
    },
    isImage (file) {
      return this.imageMime.includes(file.fileType);
    },
    mimeIcons (file) {
      return this.imageMime.includes(file.fileType)
        ? 'image'
        : 'insert_drive_file';
    },
    showDetail (file) {
      this.editedIndex = this.documents.indexOf(file);
      this.formdata = Object.assign({}, file);

      documentUsers(this.formdata.documentID)
        .then(response => {
          this.formdata.userID = response.data;
          this.loader = false;
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });

      this.uploadFile = true;
    },
    showFiles (item) {

      this.documents = this.allFiles.filter(f => f.departmentID == item.value);
      this.view = 'list';
    },
    downloadFile (key) {

      this.loader = true;
      downloadFile(this.formdata.attachments[key])
        .then(response => {
          let blob = new Blob([response.data], { type: this.editFile.contentType })
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = this.editFile.name
          link.click()
          this.loader = false;
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });

    },
    InitilizeTab () {
      window.getApp.$emit('INITIALIZE_FOLDERFILE', this.formdata);
      this.$eventHub.$emit('INITIALIZE_FOLDERCONVER', this.formdata);
      window.getApp.$emit('INITIALIZE_SUBFOLDER', this.formdata.folderID);

      window.getApp.$emit('ENABLE_FOLDERACTION');
    },
    // selectProject (value) {
    //   getTeamMember(value)
    //     .then(response => {
    //       this.formdata.assignedCC = [];

    //       for (var prop in response.data) {
    //         this.formdata.assignedCC.push(response.data[prop]);
    //       }
    //     })
    //     .catch(error => {
    //       this.loader = false;
    //       window.getApp.$emit('APP_API_ERROR', error);
    //     });
    // },
    saveDocumentAccess () {

      this.loader = true;

      // if (this.documentAccess.documentAccessID > -1) {
      //   this.documentAccess.documentID = this.documentID;
      //  // this.documentAccess.userIDs = this.folderAccessPermission.cCItems;         
      //   updateDocumentAccess(this.documentAccess)
      //     .then(response => {
      //       this.loader = false;
      //       this.actionButton = true;
      //       window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.UPDATE);
      //       this.InitilizeTab();

      //     })
      //     .catch(error => {
      //       this.loader = false;
      //       window.getApp.$emit('APP_API_ERROR', error);
      //     });
      // } else {
      this.formdata.documentAccessID = parseInt(Math.random() * 100) + 1024; // mock a id
      this.documentAccess.documentID = this.documentID;
      createDocumentAccess(this.documentAccess)
        .then(response => {
          this.loader = false;
          this.documentAccess = response.data;

          window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.SAVE);
          this.InitilizeTab();
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
      // }


    },
    save () {
      if (this.$refs.validateform.validate()) {
        this.loader = true;

        if (this.formdata.folderID > -1) {
          this.formdata.modifiedByUserId = this.$store.state.auth.userId;
          this.formdata.modifiedDate = new Date().toISOString().substr(0, 10);
          this.formdata.addedByUserId = this.$store.state.auth.userId;
          this.formdata.addedDate = new Date().toISOString().substr(0, 10);
          updateFolders(this.formdata)
            .then(response => {
              this.loader = false;
              this.actionButton = true;
              window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.UPDATE);
              this.InitilizeTab();

            })
            .catch(error => {
              this.loader = false;
              window.getApp.$emit('APP_API_ERROR', error);
            });
        } else {
          //this.formdata.folderID = parseInt(Math.random() * 100) + 1024; // mock a id
          this.formdata.addedByUserId = this.$store.state.auth.userId;
          this.formdata.addedDate = new Date().toISOString().substr(0, 10);
          this.formdata.statusCodeID = 1;
          createFolders(this.formdata)
            .then(response => {
              this.loader = false;
              this.formdata = response.data;

              window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.SAVE);
              this.InitilizeTab();
            })
            .catch(error => {
              this.loader = false;
              window.getApp.$emit('APP_API_ERROR', error);
            });
        }
      }
      else {
        window.getApp.$emit('APP_API_VAL', GlobalMessage.VALIDATE);
      }
    },
    closeDial () {
      confirm('Confirm to close not save')
        .then(result => {

          console.log(result);
        });
      // window.getApp.$emit('APP_API_VAL', 'Confirm to close');
    }
  },
};
</script>
<style lang="stylus" scoped>
.quill {
  height: 250px;
}
</style>


// WEBPACK FOOTER //
// src/pages/document/folderForm.vue